import React from 'react';
import { IColumnRowProps } from './columnPreferences.types';
import { Checkbox } from 'antd';
import { ReactComponent as DragIcon } from '../../assets/icons/drag-outlined.svg';

const ColumnRow: React.FC<IColumnRowProps> = ({
  columnName,
  index,
  isChecked,
  isDragging,
  onToggle,
  onDragStart,
  onDragEnter,
  onDragEnd
}) => (
  <li
    className={`arrange-columns-row${isDragging ? ' arrange-columns-row--dragging' : ''}`}
    draggable
    onDragStart={() => onDragStart(index)}
    onDragEnter={() => onDragEnter(index)}
    onDragEnd={onDragEnd}
    onDragOver={event => event.preventDefault()}
    data-testid={`arrange-column-row-${columnName}`}
  >
    <span className='arrange-columns-row-handle' aria-hidden='true'>
      <DragIcon />
    </span>
    <Checkbox checked={isChecked} onChange={() => onToggle(columnName)}>
      {columnName}
    </Checkbox>
  </li>
);

export default ColumnRow;